module.exports = __webpack_public_path__ + "static/media/BannerCategoria_X2.1dcae03e.jpg";